import { render } from "./ContractNoAccess.vue?vue&type=template&id=22650eb2&scoped=true"
import script from "./ContractNoAccess.vue?vue&type=script&lang=js"
export * from "./ContractNoAccess.vue?vue&type=script&lang=js"

import "./ContractNoAccess.vue?vue&type=style&index=0&id=22650eb2&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22650eb2"]])

export default __exports__